import  { useRef } from "react";
import ProfileImage from "../../../../../assets/Images/TestImg/profileImage.png";
import PDFBranding from "../../../../Universal/SAS Branding/PDFBranding.component";
import { Helmet } from "react-helmet";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import PieChartComponent from "../../../../Universal/PieChart.component";
import Title from "../../../../Universal/Title.component";
import html2pdf from "html2pdf.js";
import DownloadStudentBasicData from "./DownloadStudentBasicData.component";
const StudentProfileOverview = ({ studentsData, convertToTitleCase }) => {
  const printableRef = useRef(null);
  const renderStudentCardDetails = (json) => {
    try {
      const obj = typeof json === "string" ? JSON.parse(json) : json; // Parse if string, otherwise use as is
      if (typeof obj === "object" && obj !== null) {
        const objectKey = Object.keys(obj);
        return objectKey.map((key) => {
          console.log("academic", typeof json[key]);
          return (
            <div className="flex-row align-center justify-start g-05">
              <span className="t-14 poppins color-grayColor">
                {convertToTitleCase(key)} :
              </span>
              {typeof json[key] === "object" ? (
                <div className="flex-row align-start justify-start g-05">
                  {json[key].map((li) => (
                    <span className="t-14 poppins color-greenColor">
                      {convertToTitleCase(li)},
                    </span>
                  ))}
                </div>
              ) : (
                <span className="t-14 poppins color-greenColor">
                  {json[key]}
                </span>
              )}
            </div>
          );
        });
      } else {
        return []; // Return empty array for non-objects or null
      }
    } catch (error) {
      console.error("Invalid JSON:", error);
      return []; // Return empty array on parsing error
    }
  };
  const overViewSection = useRef(null);
  const downloadStudentData = () => {
    const element = document.getElementById("pdf-content");
    const opt = {
      margin: 0.5,
      filename: "Student-Profile.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <section
      ref={overViewSection}
      className="w-full flex-col align-start justify-start g-1"
    >
      <DownloadStudentBasicData
        ref={printableRef}
        student={{ ...studentsData, image: ProfileImage }}
        schoolDetails={{
          schoolName: "Elementary School of Business and Social Sciences",
          schoolAddress:
            "15, Grand Trunk Rd, Deshbandhu Park, Uttarpara, Kolkata, West Bengal 700134",
        }}
      />

      <Helmet>
        <title>Student Profile Overview</title>
      </Helmet>
      <div className="w-full relative flex-row align-center justify-center">
        <div className="flex-col align-center justify-center g-05">
          <img
            src={ProfileImage}
            alt="profileIm"
            style={{ width: "4.5rem", height: "4.5rem", borderRadius: "50%" }}
          />
          <div className="flex-col align-center justify-center">
            <div className="t-20 poppins">{"Md Rejuwanul Karim"}</div>
            <div className="t-13 poppins color-grayColor">
              {"ID. SM1024720"}
            </div>
          </div>
        </div>
        <div className="studentProfileActions">
          <button className="deleteBtnFill t-13 poppins">Delete profile</button>
          <button
            className="actionBtn t-13 poppins"
            onClick={(e) => downloadStudentData(e)}
          >
            Download student details
          </button>
        </div>
      </div>

      {/*students overview cards*/}
      <div className="flex-row align-center justify-between g-1">
        <div
          className="flex-row align-center justify-center radius-6 back-white border-green1 pb-1 pt-1 pl-2 pr-2"
          style={{ height: "4.5rem" }}
        >
          <span className="t-15 poppins text-no-wrap">Class : &nbsp;</span>
          <span className="color-greenColor t-15 poppins">
            {studentsData.academic.currentClass}
          </span>
        </div>
        <div
          className="flex-row align-center justify-center radius-6 back-white border-green1 pb-1 pt-1 pl-2 pr-2"
          style={{ height: "4.5rem" }}
        >
          <span className="t-15 poppins text-no-wrap">Hobbies : &nbsp;</span>
          <span className="color-greenColor t-15 poppins">
            {studentsData.academic.hobbies}
          </span>
        </div>
        <div
          className="flex-row align-center justify-center radius-6 back-white border-green1 pb-1 pt-1 pl-2 pr-2"
          style={{ height: "4.5rem" }}
        >
          <span className="t-15 poppins text-no-wrap">Stars : &nbsp;</span>
          <span className="color-greenColor t-15 poppins">12</span>
        </div>
        <div
          className="flex-row align-center justify-center radius-6 back-white border-green1 pb-1 pt-1 pl-2 pr-2"
          style={{ height: "4.5rem" }}
        >
          <span className="t-15 poppins text-no-wrap">
            Reporting teacher : &nbsp;
          </span>
          <span className="color-greenColor t-15 poppins">
            {studentsData.academic.reportingTeacher}
          </span>
        </div>
        <div
          className="flex-row align-center justify-center radius-6 back-white border-green1 pb-1 pt-1 pl-2 pr-2"
          style={{ height: "4.5rem" }}
        >
          <span className="t-15 poppins text-no-wrap">
            Last Payment: &nbsp;
          </span>
          <span className="color-greenColor t-15 poppins">Paid</span>
        </div>
      </div>
      {/* students second overview card  */}
      <div className="studentSecondOverviewCardContainer">
        <div
          className="studentSecondCards"
          style={{ background: "var(--shadePink)" }}
        >
          <div className="flex-col">
            <span className="t-14 poppins" style={{ color: "var(--deepPink)" }}>
              Attendance
            </span>
            <span style={{ color: "var(--purple)" }} className="t-24">
              56/63
            </span>
          </div>
          <div className="t-20 flex-row align-end justify-end">
            <span
              style={{
                color: "var(--purple)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              67.
            </span>
            <span
              style={{ color: "var(--purple)", fontWeight: "600" }}
              className="t-24 poppins"
            >
              46
            </span>
            <span
              style={{
                color: "var(--purple)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              %
            </span>
          </div>
        </div>

        <div
          className="studentSecondCards"
          style={{ background: "var(--shadeGreen)" }}
        >
          <div className="flex-col">
            <span
              className="t-14 poppins"
              style={{ color: "var(--deepGreen4)" }}
            >
              Performance
            </span>
            <span style={{ color: "var(--deepGreen3)" }} className="t-24">
              56/63
            </span>
          </div>
          <div className="t-20 flex-row align-end justify-end">
            <span
              style={{
                color: "var(--deepGreen3)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              67.
            </span>
            <span
              style={{ color: "var(--deepGreen3)", fontWeight: "600" }}
              className="t-24 poppins"
            >
              46
            </span>
            <span
              style={{
                color: "var(--deepGreen3)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              %
            </span>
          </div>
        </div>
        <div
          className="studentSecondCards"
          style={{ background: "var(--shadeOrange1)" }}
        >
          <div className="flex-col">
            <span
              className="t-14 poppins"
              style={{ color: "var(--deepOrange1)" }}
            >
              Last exam
            </span>
            <span style={{ color: "var(--deepOrange1)" }} className="t-24">
              8/8
            </span>
          </div>
          <div className="t-20 flex-row align-end justify-end">
            <span
              style={{
                color: "var(--deepOrange2)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              89.
            </span>
            <span
              style={{ color: "var(--deepOrange2)", fontWeight: "600" }}
              className="t-24 poppins"
            >
              86
            </span>
            <span
              style={{
                color: "var(--deepOrange2)",
                fontWeight: "500",
                fontSize: "43px",
              }}
              className="t-26 poppins"
            >
              %
            </span>
          </div>
        </div>
      </div>
      <div className="studentProfileDetailsGrid">
        {/* students basic details */}
        <div className="studentsDetailsCard studentBasicDetails">
          <div className="flex-col align-start justify-start g-2 h-full">
            <p className="t-17 color-grayColor" style={{ height: "1rem" }}>
              Basic Details
            </p>
            <div className="flex-row flex-1 align-start justify-start g-1">
              <div className="w-half h-full flex-col align-start justify-start g-05">
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Full Name :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.name}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Father's Name :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.fathersName}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Mother's Name :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.mothersName}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Gurdian :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.gurdian}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Gurdian phone :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.guardianPhoneNo}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">Gender :</span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.gender}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Aadhaar number :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.aadhaarNo}
                  </span>
                </div>
              </div>
              <div className="w-half h-full flex-col align-start justify-start g-05">
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Date of birth :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.dob}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Address :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.address}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">PIN :</span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.pincode}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">
                    Nationality :
                  </span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.nationality}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">Phone :</span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.phone}
                  </span>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <span className="t-14 poppins color-grayColor">Email :</span>
                  <span className="t-14 poppins color-greenColor">
                    {studentsData.email}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Student Subject Strenght details */}
        <div className="studentsDetailsCard studentSubjectStrenght">
          {/* <DonutChart/> */}
          <div
            className="overflow-hide h-full flex-col align-left juetify-start g-1 w-full"
            style={{ padding: 0 }}
          >
            {/* staffs attendance*/}

            <div
              className="flex-row align-center justify-between w-full"
              style={{ height: "4rem" }}
            >
              <Title>Department wise appearance</Title>
              <SelectFilter />
            </div>

            <div className="flex-col align-left justify-start w-full scroll-y pr-1 flex-1">
              <div className="flex-col align-left justify-start g-1 w-full h-fit overflex-hide h-full">
                <PieChartComponent
                  data={studentsData?.subjectStrengths}
                  nameKey="name"
                  valueKey="strength"
                  totalKey="totalVal"
                  width={400}
                  height={300}
                />

                <div className="countPieChartData">
                  <ul>
                    {studentsData?.subjectStrengths?.map((entry) => {
                      return (
                        <li
                          style={{
                            border: `2px solid ${entry?.color}`,
                            background: entry?.backgroundColor,
                          }}
                        >
                          <span style={{ color: entry?.color }}>
                            {entry?.name}
                          </span>
                          <span style={{ color: entry?.color }}>
                            {entry?.strength}%
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Academic details */}
        <div className="studentsDetailsCard studentAcademic">
          <div className="flex-col align-start justify-start g-2 h-fit">
            <p className="t-17 color-grayColor" style={{ height: "1rem" }}>
              Academic
            </p>
            <div className="flex-col flex-1 align-start justify-start g-1">
              {renderStudentCardDetails(studentsData && studentsData.academic)}
            </div>
          </div>
        </div>
        {/*Student Residential details */}

        <div className="studentsDetailsCard studentResidential">
          <div className="flex-col align-start justify-start g-2 h-full">
            <p className="t-17 color-grayColor" style={{ height: "1rem" }}>
              Residential
            </p>
            <div className="flex-col flex-1 align-start justify-start g-1">
              {renderStudentCardDetails(
                studentsData && studentsData.residential
              )}
            </div>
          </div>
        </div>
        {/*Student Achivement details */}
        <div className="studentsDetailsCard studentAchivement">
          <div className="flex-col align-start justify-start g-2 h-fit">
            <p className="t-17 color-grayColor" style={{ height: "1rem" }}>
              Academic
            </p>
            <div className="flex-col flex-1 align-start justify-start g-1">
              {studentsData &&
                studentsData.achievements.map((_achi, index) => {
                  return (
                    <div className="flex-row align-center justify-start g-05">
                      <span className="t-14 poppins color-grayColor">
                        {_achi.title} :
                      </span>
                      <span className="t-14 poppins color-greenColor">
                        {_achi.position}
                      </span>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-col align-start g-05 w-full">
        <hr className="w-full" />
        <PDFBranding />
      </div>
    </section>
  );
};

export default StudentProfileOverview;
